<template>
  <div>
    <b-row align-v="center" align-h="around">
      <b-col cols="12" lg="5">
        <h1 class="mb-4">
          <strong>Pour prendre rendez-vous</strong>, complétez vos informations
        </h1>
        <img
          src="../assets/second.svg"
          alt="Person"
          class="img-fluid d-none d-lg-block mt-5"
        />
      </b-col>
      <b-col cols="12" lg="6">
        <b-card class="shadow-lg p-0 p-sm-2" v-if="identified" :key="1">
          <h3 class="mb-3">Vos informations</h3>
          <p>
            Gagnez du temps en remplissant les informations dont votre
            interlocuteur {{ $root.slugData.name }} à besoin pour ce
            rendez-vous.
          </p>
          <div class="d-block text-danger mb-2" v-if="error">
            {{ error }}
          </div>

          <b-form v-on:submit.prevent="identify">
            <b-form-group label="Prénom" label-for="input-firstname">
              <b-form-input
                id="input-firstname"
                placeholder="Martin"
                v-model="data.firstname"
                v-on:keyup.enter="identify"
                required
              />
            </b-form-group>
            <b-form-group label="Nom" label-for="input-lastname">
              <b-form-input
                id="input-lastname"
                placeholder="Dupont"
                v-model="data.lastname"
                required
                v-on:keyup.enter="identify"
              />
            </b-form-group>
            <div v-on:click="move()">
              <b-form-group label="Email" label-for="input-email">
                <b-form-input
                  id="input-email"
                  v-model="data.email"
                  disabled
                  type="email"
                  required
                />
              </b-form-group>
            </div>
            <b-form-group label="Numéro de téléphone" label-for="input-phone">
              <vue-tel-input
                id="input-phone"
                v-model="data.phone.number"
                v-on:keyup.enter.native="identify"
                class="form-control"
                dynamicPlaceholder
                required
                v-on:validate="verifyTel"
                :class="{
                  'is-valid': validation.phone,
                  'is-invalid': validation.phone === false,
                }"
              />
            </b-form-group>

            <p>
              <small
                >En cliquant sur le bouton ci-dessous, j’accepte que mes données
                soient conservées le temps nécessaire.</small
              >
            </p>

            <b-button
              variant="primary"
              v-on:submit="identify"
              v-on:click="identify"
              round
              block
              class="mt-4"
              >Valider mes informations</b-button
            >
          </b-form>
        </b-card>

        <b-card class="shadow-lg p-2" v-else :key="2">
          <h3 class="mb-3">Identification</h3>
          <p>
            Gagnez du temps en remplissant les informations dont votre
            interlocuteur {{ $root.slugData.name }} à besoin pour ce
            rendez-vous.
          </p>
          <div class="d-block text-danger mb-2" v-if="error">
            {{ error }}
          </div>

          <b-form v-on:submit.prevent="identify">
            <b-form-group label="Email" label-for="input-email">
              <b-form-input
                id="input-email"
                placeholder="martin.dupont@email.com"
                v-model="data.email"
                :disabled="identified"
                v-on:keyup.enter="identify"
                type="email"
                required
              />
            </b-form-group>
            <b-button
              variant="primary"
              v-on:submit="identify"
              v-on:click="identify"
              round
              block
              class="mt-4"
              >S'identifier
              <b-spinner small type="grow" class="ml-2" v-if="loading"
            /></b-button>
          </b-form>
        </b-card>
      </b-col>
      <b-col cols="11" lg="12" class="d-lg-none my-5">
        <img src="../assets/second.svg" alt="Person" class="img-fluid" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getDossiersByEmailAsync } from "../api/dossierApi.js";
import { VueTelInput } from "vue-tel-input";

export default {
  name: "Identification",
  components: {
    VueTelInput,
  },
  data() {
    return {
      identified: false,
      data: {
        email: null,
        firstname: null,
        lastname: null,
        phone: {
          number: null,
          mobile: null,
        },
      },
      error: "",
      validation: {
        phone: null,
      },
      isRetrying: false,
      loading: false,
    };
  },

  props: {
    user: Object,
  },
  mounted() {
    if (this.user.dossierId) {
      this.data = this.user;
      this.identified = false;
    } else if (this.user.email) {
      this.data = this.user;
      this.identified = true;
    }
  },

  methods: {
    verifyTel(e) {
      this.validation.phone = e.possible;
      if (this.validation.phone) this.data.phone.mobile = e.type === "mobile";
    },
    async identify() {
      this.loading = true;
      if (!this.identified) {
        if (
          !this.data.email ||
          !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            this.data.email
          )
        )
          this.error = "Veuillez renseigner une adresse email valide";
        else {
          this.error = "";

          try {
            var result = await getDossiersByEmailAsync(
              this.data.email,
              this.$root.slug
            );
          } catch (e) {
            this.identified = false;
            this.loading = false;
            this.error =
              "Une erreur est survenue, veuillez vérifier votre connexion internet.";
            return;
          }

          if (!result) {
            this.identified = true;
          } else {
            //if (this.isRetrying) {
            this.isRetrying = false;
            this.data.dossierId = result.id;
            this.$emit("update", this.data);
            // } else {
            //   this.isRetrying = true;
            //   this.error =
            //     "Vous avez déjà eu un premier entretien avec nous ? Contactez directement le consultant qui vous accompagne pour obtenir un rendez-vous personnalisé à votre convenance. Vous pouvez également prendre un rendez-vous en ligne avec un nouveau consultant en cliquant sur 's'identifier'";
            // }
          }
        }
      } else {
        if (
          this.data.email &&
          this.data.firstname &&
          this.data.lastname &&
          this.validation.phone
        ) {
          this.error = null;
          this.$emit("update", this.data);
        } else this.error = "Tous les champs sont obligatoires";
      }
      this.loading = false;
    },

    move() {
      if (this.identified) this.identified = false;
    },
  },
};
</script>

<style lang="scss">
input:disabled {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
